import { Component } from 'react';
import { compose } from 'recompose';
import { ChartFragment, Section } from 'models/api-response';
import { FormFieldInputType } from 'models/enum';
import { ChartActionsComponentProps, ChartComponentProps, ChartMetaFormField } from 'models/ui';
import { chartHelper } from 'helpers';
import { chartService } from 'services';
import { withChartLogic } from 'components/common';
import withSavedPatientChartsPage from 'components/features/shared/withSavedPatientChartsPage';
import { FormField, SectionTitle } from './constants';
import GenitourinaryInterventionsView from './GenitourinaryInterventionsView';
import { Title } from '../shared/constants';

class GenitourinaryInterventions extends Component<ChartComponentProps> {
  static displayName = 'GenitourinaryInterventions';

  componentDidMount() {
    this.props.initState(this.buildDefaultFormFields());
  }

  buildDefaultFormFields = (): Map<string, ChartMetaFormField> => {
    const { createFormField } = chartHelper;
    const dataMap = new Map();
    const multiselectDropdowns = [FormField.URINARY_SYSTEM_CARE, FormField.DRAIN_TUBE_CARE, FormField.PATIENT_RESPONSE];

    dataMap.set(FormField.NO_ASSESSMENT_REQUIRED, createFormField({ name: FormField.NO_ASSESSMENT_REQUIRED, type: FormFieldInputType.CHECK_BOX }));
    multiselectDropdowns.forEach((name) => dataMap.set(name, createFormField({ name, type: FormFieldInputType.MULTISELECT_DROPDOWN })));
    dataMap.set(FormField.GENITOURINARY_CARE_NOTES, createFormField({ name: FormField.GENITOURINARY_CARE_NOTES, type: FormFieldInputType.TEXT_AREA }));
    return dataMap;
  };

  createSections = (): Section[] => {
    const { formFieldMap } = this.props;
    const { buildSection } = chartHelper;
    return [
      buildSection({ sectionTitle: SectionTitle.GENITOURINARY_INTERVENTIONS, fields: [FormField.NO_ASSESSMENT_REQUIRED], formFieldMap }),
      buildSection({ sectionTitle: SectionTitle.URINARY_SYSTEM_CARE, fields: [FormField.URINARY_SYSTEM_CARE], formFieldMap }),
      buildSection({ sectionTitle: SectionTitle.DRAIN_TUBE_CARE, fields: [FormField.DRAIN_TUBE_CARE], formFieldMap }),
      buildSection({ sectionTitle: SectionTitle.PATIENT_RESPONSE, fields: [FormField.PATIENT_RESPONSE], formFieldMap }),
      buildSection({ sectionTitle: SectionTitle.GENITOURINARY_CARE_NOTES, fields: [FormField.GENITOURINARY_CARE_NOTES], formFieldMap })
    ];
  };

  buildFragment = () => {
    const record = {
      chartTitle: Title.SYSTEM_NURSING_INTERVENTIONS,
      fragmentTitle: SectionTitle.GENITOURINARY_INTERVENTIONS,
      records: this.createSections()
    };
    const cleanRecord = chartService.systemAssessment.removeEmptyRecords(record);
    const basicInfo = chartService.createBaseFragment({ chartingTime: this.props.chartingTime });
    return { ...basicInfo, chartData: cleanRecord } as ChartFragment;
  };

  handleSaveClick = () => {
    this.props.saveChart([this.buildFragment()], { afterSave: this.props.backToSourceLocation || this.props.navigateToSavedPatientCharting });
  };

  render() {
    const chartActionsProps: ChartActionsComponentProps = {
      enableDisplayRecordsButton: this.props.enableDisplayRecordsButton,
      enableSaveButton: this.props.hasUnsavedChanges,
      onDisplayRecordsClick: this.props.displayAuthoringData,
      onSaveClick: this.handleSaveClick,
      onCancelClick: () => this.props.handleDiscardClick(undefined, this.buildDefaultFormFields())
    };
    const viewProps = {
      chartActionsProps,
      formFieldMap: this.props.formFieldMap,
      formSubmittedCount: this.props.formSubmittedCount
    };
    return <GenitourinaryInterventionsView {...viewProps} />;
  }
}

export { GenitourinaryInterventions as BaseGenitourinaryInterventions };
export default compose(withSavedPatientChartsPage, withChartLogic)(GenitourinaryInterventions);
